<template>
  <div class="conditions-box">
    <div v-show="!isSp" class="conditions-box-shadow">
    </div>
    <div class="conditions-box-content container">
      <div class="row condition-box-header">
        <div class="col-md-12">
          <i class="fas fa-bars mr-2"></i><b>カテゴリー</b>
        </div>
        <div class="col-md-12">
          <hr class="condition-box-hr" style="margin-bottom: 0px;">
        </div>
        <div class="col-md-12 mb-3 mt-1">
          <div class="mt-3 left" v-for="category in categories" :key="category">
            <a class="article-category-link" :href="`/articles?category=${category}`">{{category}}</a>
            <hr style="margin: 6px 0px; border-color: #A7ACAE;">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { restMethods } from '../mixins/rest_methods'
export default {
  data() {
    return {
    }
  },
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    isSp:{
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  methods: {
  },
  created(){
    
  },
  computed: {
  },
  watch: {
  }
}
</script>